import { gtmPagePushOrderListing } from '../../modules/ga/GTMdatalayer';

const d = new Date();
const currentYear = d.getFullYear();
const currentYear1 = currentYear - 1;
const currentYear2 = currentYear - 2;
const currentYear4 = currentYear - 4;

const getFilterListConfig = () => {
  const listItem = [
    {
      key: 'LAST30DAYS',
      value: 'Last 30 days'
    },
    {
      key: 'LAST6MONTH',
      value: 'Last 6 months'
    },
    {
      key: 'CURRENT_YEAR',
      value: currentYear
    },
    {
      key: 'CURRENT_YEAR-1',
      value: currentYear1
    },
    {
      key: 'CURRENT_YEAR-2',
      value: currentYear2
    },
    {
      key: 'CURRENT_YEAR-4',
      value: currentYear4
    }
  ];
  return listItem;
};
const filterValues = (acc, range) => ({ ...acc, [range.key]: range.value });
const gaForOrderListing = (ordersData, dateRange) => {
  const { pagination = {}, totalOrders = 0, orderDateRange = [] } = ordersData;
  const { currentPage = 0 } = pagination;
  const dateFilter = orderDateRange.reduce(filterValues, {});
  gtmPagePushOrderListing(
    'order listing screen',
    'order management screen',
    totalOrders,
    currentPage,
    dateFilter[dateRange]
  );
};

export { getFilterListConfig, gaForOrderListing };
